export const API_SERVER = process.env.REACT_APP_PUBLIC_API_SERVER;

export const CRM_INTAKE_URL = process.env.REACT_APP_CRM_INTAKE_URL;
export const CRM_INTAKE_TOKEN = process.env.REACT_APP_CRM_INTAKE_TOKEN;
